import React, { Fragment } from 'react'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import { obtenerSolicitudesUIFC01 } from '../../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck'
import SolicitudesEstatusUIComponent from './SolicitudesEstatusUIComponent';

function TabsSolicitudesEstatusUIComponent(props) {

    const dispatch = useDispatch()

    const [tabSolicitudes, setTabSolicitudes] = React.useState('estatus1');
    const [solicitudes, setSolicitudes] = React.useState([]);
    
    const solicitudesEstatus = []

    React.useEffect(async () => {
        if (tabSolicitudes == 'estatus1'){
            let resEstatus1 = await dispatch(obtenerSolicitudesUIFC01(1))
            setSolicitudes(resEstatus1?.payload)
        }
        if (tabSolicitudes == 'estatus2'){
            let resEstatus2 = await dispatch(obtenerSolicitudesUIFC01(2))
            setSolicitudes(resEstatus2?.payload)
        }
        if (tabSolicitudes == 'estatus3'){
            let resEstatus3 = await dispatch(obtenerSolicitudesUIFC01(3))
            setSolicitudes(resEstatus3?.payload)
        }
        if (tabSolicitudes == 'estatus4'){
            let resEstatus4 = await dispatch(obtenerSolicitudesUIFC01(4))
            setSolicitudes(resEstatus4?.payload)
        }
    }, [tabSolicitudes])
    
    
    solicitudes?.map(solicitud => {
        let cadena = []
        if (solicitud?.fc_01_solicitudderegistro?.viverista) cadena.push('Viverista')
        if (solicitud?.fc_01_solicitudderegistro?.productormaguey) cadena.push('Productor de maguey')
        if (solicitud?.fc_01_solicitudderegistro?.productormezcal) cadena.push('Productor de mezcal')
        if (solicitud?.fc_01_solicitudderegistro?.envasador) cadena.push('Envasador')
        if (solicitud?.fc_01_solicitudderegistro?.comercializadormezcal) cadena.push('Comercializador de mezcal')
        if (solicitud?.fc_01_solicitudderegistro?.comercializadorbebidasconmezcal) cadena.push('Comercializador de bebidas con mezcal')

        let combinacionCadena = ''
        let contador = 1
        for (const i in cadena) {
            if (cadena.length === 1) {
                combinacionCadena += cadena[i]
            } else {
                if (cadena.length === (contador + 1)) {
                    combinacionCadena += cadena[i] + ' y '
                    contador++
                } else {

                    combinacionCadena += cadena[i]
                    if (cadena.length !== contador) {
                        combinacionCadena += ', '
                    }
                    contador++
                }
            }
        }

        let estatus = ''
        if (solicitud.statusdelasolicitud == 1) estatus = 'Asignada al inspector'   
        if (solicitud.statusdelasolicitud == 2) estatus = 'Informe emitido'            
        if (solicitud.statusdelasolicitud == 3) estatus = 'Informe en revisión'
        if (solicitud.statusdelasolicitud == 4) estatus = 'Dictamen emitido'

        solicitudesEstatus.push({
            id: uuidv4(), idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro,
            numerosocio: solicitud.fc_01_solicitudderegistro.numerosocio, tipoSolicitud: 'Solicitud de inscripción',
            nombrerazonsocial: solicitud.fc_01_solicitudderegistro.nombrerazonsocial,
            idlogin: solicitud.fc_01_solicitudderegistro.idlogin, idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
            data: solicitud, estatus: estatus, inspector: solicitud?.inspector?.nombre, cadena: combinacionCadena
        })
    })

    const handleChangeSolicitudesTab = (event, newValue) => {
        setTabSolicitudes(newValue);
    };

    React.useEffect(async () => {
        await dispatch(obtenerSolicitudesUIFC01(1))
    }, [])

    return (
        <Fragment>
            <Box sx={{ width: '80%', typography: 'body1', margin: 'auto', marginTop: '5%' }}>
                <TabContext value={tabSolicitudes}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        textAlign: 'center', backgroundColor: '#fcfcfc',
                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                    }}>
                        <TabList onChange={handleChangeSolicitudesTab} aria-label="visible arrows tabs example" variant="scrollable" scrollButtons="auto" className='text-center'
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            sx={{
                                "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                            }}>
                            <Tab label="Pendiente inspección" value="estatus1" />
                            <Tab label="Informe emitido" value="estatus2" />
                            <Tab label="Informe en revisión" value="estatus3" />
                            <Tab label="Dictamen emitido" value="estatus4" />
                        </TabList>
                    </Box>
                    <TabPanel value="estatus1" style={{paddingLeft: 0, paddingRight: 0}}>
                        <SolicitudesEstatusUIComponent data={solicitudesEstatus} titulo="SOLICITUDES UI ASIGNADAS A INSPECTOR" />
                    </TabPanel>
                    <TabPanel value="estatus2" style={{paddingLeft: 0, paddingRight: 0}}>                        
                        <SolicitudesEstatusUIComponent data={solicitudesEstatus} titulo="INFORMES EMITIDOS" />                        
                    </TabPanel>
                    <TabPanel value="estatus3" style={{paddingLeft: 0, paddingRight: 0}}>                        
                        <SolicitudesEstatusUIComponent data={solicitudesEstatus} titulo="INFORMES EN REVISIÓN" />                        
                    </TabPanel>
                    <TabPanel value="estatus4" style={{paddingLeft: 0, paddingRight: 0}}>                        
                        <SolicitudesEstatusUIComponent data={solicitudesEstatus} titulo="DICTÁMENES EMITIDOS" />                        
                    </TabPanel>
                </TabContext>
            </Box>
        </Fragment >
    )
}

export default withRouter(TabsSolicitudesEstatusUIComponent)